<template>
    <div class="Box">
      <el-card class="box-card">
        <el-form :model="queryParams" size="medium" label-width="120px" class="mt35">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="订单号">
                <el-input v-model="queryParams.order_id" @change="search" placeholder="请输入订单号" clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="书籍ID">
                <el-input v-model="queryParams.source_book_id" @change="search" placeholder="请输入书籍ID" clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="书籍ID(快手端)">
                <el-input v-model="queryParams.book_id" @change="search" placeholder="请输入书籍ID(快手端)" clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="书籍名称">
                <el-input v-model="queryParams.book_name" @change="search" placeholder="请输入书名名称" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="订单类型">
                <el-select v-model="queryParams.expand_type" placeholder="请选择订单类型" @change="search" clearable style="width: 100%;">
                  <el-option label="普通订单" value="0"></el-option>
                  <el-option label="分销订单" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="购买类型">
                <el-select v-model="queryParams.sales_type" placeholder="请选择购买类型" @change="search" clearable style="width: 100%;">
                  <el-option label="全文购买" value="1"></el-option>
                  <el-option label="章节购买" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="购买方式">
                <el-select v-model="queryParams.commodity_type" placeholder="请选择购买方式" @change="search" clearable style="width: 100%;">
                  <el-option label="全文售卖" value="1"></el-option>
                  <el-option label="单集售卖" value="2"></el-option>
                  <el-option label="打包售卖" value="3"></el-option>
                  <el-option label="剩余全部章节打包售卖" value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="是否平台改价">
                <el-select v-model="queryParams.use_platform_price" placeholder="请选择是否平台改价" @change="search" clearable style="width: 100%;">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="支付渠道">
                <el-select v-model="queryParams.pay_provider" placeholder="请选择支付渠道" @change="search" clearable style="width: 100%;">
                  <el-option label="微信支付" value="2"></el-option>
                  <el-option label="支付宝" value="3"></el-option>
                  <el-option label="苹果支付" value="5"></el-option>
                  <el-option label="渠道不确定" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <el-form-item label="下单时间">
                <el-date-picker
                  v-model="queryParams.order_time"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="mb20">
              <div class="btn_left">
                <el-button type="primary" size="medium" @click="search">查询</el-button>
                <el-button @click="resetQuery" size="medium">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        
        <div class="div_buttom">
          <el-button size="medium" @click="refreshList">刷新列表</el-button>
        </div>
        
        <MyTable
          ref="myTableRef"
          :table-data="tableData"
          :columns="columns"
          :loading="loading"
          :total="total"
          :page-no="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @pagination-change="paginationChange"
        >
          <template #operation>
            <el-table-column fixed="right" label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button class="PUB_BTN_RED" type="text" size="medium" @click="addDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </MyTable>
      </el-card>
    </div>
  </template>
  
  <script>
  import { KsNovalManagement } from "@/api/ksNovalManagement";
  import { processErrors } from "@/utils/errorHandler";
  
  const api = KsNovalManagement();
  
  export default {
    components: {
    },
    data() {
      return {
        columns: [
          {
            label: '订单号',
            prop: 'order_id',
            minWidth: '160',
            fixed: true,
          },
          {
            label: '书籍ID',
            prop: 'source_book_id',
            minWidth: '120'
          },
          {
            label: '书籍ID(快手端)',
            prop: 'book_id',
            minWidth: '160'
          },
          {
            label: '书籍名称',
            prop: 'book_name',
            minWidth: '120'
          },
          {
            label: '订单类型',
            prop: 'expand_type_text',
            minWidth: '120'
          },
          {
            label: '购买类型',
            prop: 'sales_type_text',
            minWidth: '120'
          },
          {
            label: '购买方式',
            prop: 'commodity_type_text',
            minWidth: '120'
          },
          {
            label: '是否平台改价',
            prop: 'use_platform_price_text',
            minWidth: '140'
          },
          {
            label: '支付渠道',
            prop: 'pay_provider_text',
            minWidth: '160'
          },
          {
            label: '下单时间',
            prop: 'order_time',
            minWidth: '160'
          },
        ],
        queryParams: {
          pageNo: 1,
          pageSize: 10,
          order_id: "",
          source_book_id: "",
          book_id: "",
          book_name: "",
          sales_type: "",
          commodity_type: "",
          use_platform_price: "",
          pay_provider: "",
          expand_type: "",
          order_time: [],
        },
        tableData: [],
        total: 0,
        loading: false,
      };
    },
    created() {
      this.getList();
    },
    methods: {
      getList(type) {
        this.loading = true;
        if (type != 'changePage') {
          this.queryParams.pageNo = 1;
        }
        
        api.ApiOrderList(this.queryParams).then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.totalCount;
          } else {
            processErrors(res);
          }
          this.loading = false;
        });
      },
      
      paginationChange({ pageNo, pageSize }) {
        this.queryParams.pageNo = pageNo;
        this.queryParams.pageSize = pageSize;
        this.getList('changePage');
      },
      
      search() {
        this.getList();
      },
      
      resetQuery() {
        this.queryParams = {
          pageNo: 1,
          pageSize: 10,
          order_id: "",
          source_book_id: "",
          book_id: "",
          book_name: "",
          sales_type: "",
          commodity_type: "",
          use_platform_price: "",
          pay_provider: "",
          expand_type: "",
          order_time: [],
        };
        this.getList();
      },
      
      refreshList() {
        this.getList();
      },
      
      handleDateChange(value) {
        if (value && value.length === 2) {
          this.queryParams.order_time = value;
        } else {
          this.queryParams.order_time = [];
        }
        this.search()
      },
      
      addDel(row) {
        this.$confirm('确定删除该订单吗 ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          api.ApiOrderDel({id: row.id}).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getList('changePage')
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {
        
        });
      },
    }
  };
  </script>
  
  <style lang='scss' scoped>
  .el-card__body {
    padding: 0px !important;
  }
  
  .btn_left {
    margin-left: 120px;
  }
  
  .div_buttom {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }
  
  ::v-deep .el-radio input[aria-hidden="true"] {
    display: none !important;
  }
  </style>